import {
  Container,
  createStyles,
  Header,
  Image,
  useMantineTheme,
} from "@mantine/core";
import { useLogo } from "../context/Logo/LogoContext";

const useStyles = createStyles(() => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
  },
}));

export const GenderlabHeader = () => {
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const { logo } = useLogo();

  return (
    <Header height={100} mb={20}>
      <Container className={classes.header} size={1200}>
        <Image
          alt="logo"
          src={
            theme.colorScheme === "light"
              ? "/img/elsa-light.png"
              : "/img/elsa-dark.png"
          }
          width={250}
        />
        {logo && <Image alt="empresa-logo" src={logo} width={80} />}
      </Container>
    </Header>
  );
};
